import { useState, useEffect } from 'react';
import { storage, getEmitter } from '@laigu/utils';

const emitter = getEmitter();
const { getLocal, setLocal } = storage;

const useLocalstorageState = (key, defaultValue) => {
  const getStoredValue = () => getLocal(key);

  const [state, setState] = useState(() => (getLocal(key) !== undefined ? getLocal(key) : defaultValue));
  const emitKey = `localState_${key}`;

  const handleUpdateState = params => {
    setLocal(key, params);
    setState(params);
  };

  const updateState = param => {
    emitter.emit(emitKey, param);
  };

  useEffect(() => {
    const storedValue = getStoredValue();
    if (storedValue !== null && storedValue !== undefined) {
      setState(storedValue);
    }
  }, [key]);

  useEffect(() => {
    emitter.on(emitKey, handleUpdateState);
    return () => {
      emitter.off(emitKey, handleUpdateState);
    };
  }, []);

  return [state, updateState];
};

export default useLocalstorageState;
